<div class="jumbotron-block jumbotron-admin" *ngIf="isLoggedIn">
    <div class="jumbotron-bg" [ngStyle]="bgStyle">
        <div class="jumbotron-content layout-corral">
            <header-user-bar dir="ltr"></header-user-bar>
            <h1  [ngStyle]="h1Style">{{name}}</h1>
            <div></div>
        </div>
    </div>
    <div class="space jumbotron-edit-field" *ngIf="editable">
        <div class="layout-corral jumbotron-edit-field-row">
            <div class="switch-host" (click)="toggleEditMode()">
                Режим редактирования
                <switch [val]="editMode"></switch>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isRootPage && news?.length" class="jumbotron-block">    
    <swiper [config]="config"  navigation="true">
        <ng-template *ngFor="let newsItem of news" swiperSlide>
            <div class="card-slide">
                <div class="card-slide-left">
                    <div class="card-slide-text">
                        <div class="card-header">{{newsItem.title}}</div>
                        <div class="card-subheader">{{newsItem.sub}}</div>
                    </div>
                    <button class="btn outline"  [routerLink]="newsItem.link">Подробнее</button>
                </div>
                <div class="card-image">
                    <img [src]="newsItem.img">
                </div>
            </div>
        </ng-template>
    </swiper> 
    <!-- <div class="zayavka">
        <h2>Система добровольной сертификации РусРиска для риск-менеджеров</h2>
        <button class="btn outline"  [routerLink]="newsItem.link">Подать заявку на обучение</button>
    </div> -->
</div>
<div *ngIf="isRootPage" class="jumbotron-block">    
    <div class="zayavka">
        <h1>Система добровольной сертификации РусРиска для риск-менеджеров</h1>
        <a class="btn outline"  href="kontakty/forma-obratnoi-svyazi">Подать заявку на&nbsp;обучение</a>
    </div>
</div>

<div *ngIf="isRootPage && archive?.length" class="jumbotron-news">
    <h2 routerLink="publikatsii/novosti" class="jumbotron-news-link">
        Новости
        <ico ico="chevron_right_big_24" [size]="24"></ico>
    </h2>
    <div class="jumbotron-archive">
        <div class="jumbotron-archive-item" *ngFor="let archItem of archive" [routerLink]="archItem.link">
            <div>
                <div *ngIf="archItem.tag" class="tag">{{archItem.tag}}</div>
                <h4>{{archItem.title}}</h4>
                <div>{{archItem.sub}}</div>
            </div>
            <div *ngIf="archItem.img" class="card-image">
                <img [src]="archItem.img">
            </div>
        </div>
        
    </div>
</div>



